var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"navbar-simple-component"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"brand",attrs:{"to":{ name: 'home' }}},[_vm._v("\n      Pague com bitcoin\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }